import { useEffect, useRef } from 'react'

const useOutsideClickDetector = (when: boolean, callbackFn: () => void) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const clickOutside = (e: MouseEvent) => {
      //ex: 모달이 열려 있고 모달의 바깥쪽을 눌렀을 때 창 닫기
      if (when && ref.current && !ref.current.contains(e.target as Node)) {
        callbackFn()
      }
    }

    document.addEventListener('mousedown', clickOutside)

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', clickOutside)
    }
  }, [when, callbackFn])

  return {
    outside_ref: ref,
  }
}

export default useOutsideClickDetector
